import gql from "graphql-tag"

export default gql`
  query fileSearch($text: String!) {
    search: fileSearch(text: $text) {
      id,
      name
    }
  }
`